/**
 * DeviceListRow.jsx (868m4jf4v)
 *
 * Thin wrapper for the recessed --bg-page surface nested inside a
 * DeviceCard -- background: var(--bg-page), border-radius: var(--radius-
 * md). Confirmed live (7 themes checked directly against theme-tokens.css,
 * not assumed): --bg-page is darker/lower-emphasis than --bg-surface in
 * every dark theme and a duller-than-white tint of it in every light
 * theme, so this reads as "recessed" regardless of which theme is active.
 *
 * Only makes visual sense nested inside a --bg-surface container (a
 * DeviceCard) -- on the bare page background (which IS --bg-page), a row
 * using this component would have zero contrast and disappear. That is
 * exactly why this commit's scope is the port detail drawer's inset boxes
 * and the WAN card's inset network-details box (both already living
 * inside a DeviceCard as of the previous commit), and NOT yet the Radios/
 * Wireless-Clients rows, which currently render directly on the page
 * background with no DeviceCard wrapper at all -- converting those first
 * would make them invisible. They get both a DeviceCard wrapper and this
 * component together, in the dedicated WAN/Radios/Wireless-Clients
 * migration commit later in this ticket, so the two changes land as one
 * working state, never a half-applied one.
 */

export default function DeviceListRow({ className, style, children, ...rest }) {
  return (
    <div className={['dd-list-row', className].filter(Boolean).join(' ')} style={style} {...rest}>
      {children}
    </div>
  );
}
